import { z } from 'zod';
import { ID } from '../../utils/codecUtils';

export const deleteEndpoint = (hookId: ID) => {
  return {
    endpoint: `/hooks/${hookId}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
